<template>
  <div>
    <Loading :loading="this.loading"></Loading>
    <div v-show="!this.loading" v-if="isInitialAgreement">
      <div class="content-wrapper bg-light-blue-violet font-family-noto-sans-jp">
        <div class="container">
          <article>
            <section class="initial-agreement-sentence-wrapper">
              <div class="initial-agreement-sentence-content">
                <h2 class="initial-agreement-sentence">
                  洗車プリペイドの<br>
                  利用規約をご確認の上、<br>
                  残高をチャージしてください
                </h2>
                <p class="initial-agreement-sentence-store-name">ご利用店舗：<br>{{ ssInfo.ss_name }}</p>
                <div class="initial-agreement-sentence-caution">
                  <p class="initial-agreement-sentence-caution-title"><strong>特に以下の点にご注意ください</strong></p>
                  <ul class="initial-agreement-sentence-caution-list">
                    <li>残高の有効期限はチャージから180日です</li>
                    <li>上記の利用店舗でのみ使えます</li>
                    <li>払い戻しはできません</li>
                  </ul>
                </div>
              </div>
            </section>
            <div class="initial-agreement-button-wrapper">
              <div class="initial-agreement-button-term">
                <button class="" v-on:click="toAgreement()">
                  <span>利用規約</span>
                  <img src="/lib/images/right_arrow_green_thin.svg" alt="right_arrow_green">
                </button>
              </div>
              <div class="initial-agreement-button-next">
                <button class="" v-on:click="toChargeFromInitialAgreement()">
                  <span>上記に同意して次へ</span>
                  <img src="/lib/images/right_arrow_white.svg" alt="right_arrow_white">
                </button>
              </div>
            </div>
          </article>
        </div>
        <!-- ネイティブからJSを実行して洗車TOPへ戻るために、クエリパラメータを格納する。 -->
        <input id="tsid" type="hidden" name="tsid" v-bind:value="nativeData.tsid">
        <input id="otoken" type="hidden" name="otoken" v-bind:value="nativeData.otoken">
        <input id="popinfoid" type="hidden" name="popinfoid" v-bind:value="nativeData.popinfoid">
        <input id="authid" type="hidden" name="authid" v-bind:value="nativeData.authid">
        <input id="ss_code" type="hidden" name="ss_code" v-bind:value="nativeData.ss_code">
        <input id="x_cls_app_version" type="hidden" name="x_cls_app_version" v-bind:value="nativeData.x_cls_app_version">
        <input id="x_cls_os" type="hidden" name="x_cls_os" v-bind:value="nativeData.x_cls_os">
        <input id="x_cls_os_version" type="hidden" name="x_cls_os_version" v-bind:value="nativeData.x_cls_os_version">
        <input id="dpi" type="hidden" name="dpi" v-bind:value="nativeData.dpi">
        <input id="device_pixel_ratio" type="hidden" name="device_pixel_ratio" v-bind:value="nativeData.devicePixelRatio">
      </div>
    </div>
    <div v-else-if="isAgreement">
      <a id="isAgreement" v-on:click="toInitialAgreement()"></a>
      <Agreement></Agreement>
    </div>
  </div>
</template>

<script>
import Agreement from '@/views/v2/Agreement.vue'
import ssApi from '@/store/Api/ss'
import modal from '@/assets/v2/modal'
import Loading from '@/views/v2/Loading'

const IS_INITIAL_AGREEMENT = 'IS_INITIAL_AGREEMENT'
const IS_AGREEMENT = 'IS_AGREEMENT'

export default {
  data () {
    return {
      loading: true,
      ssInfo: [],
      currentState: IS_INITIAL_AGREEMENT
    }
  },
  computed: {
    isInitialAgreement () {
      return this.currentState === IS_INITIAL_AGREEMENT
    },
    isAgreement () {
      return this.currentState === IS_AGREEMENT
    },
    nativeData: function () {
      const getData = {}
      // ネイティブから取得したクエリパラメータを格納する。
      getData.tsid = this.$route.query.tsid
      getData.popinfoid = this.$route.query.popinfoid
      getData.otoken = this.$route.query.otoken
      getData.authid = this.$route.query.authid
      getData.ss_code = this.$route.query.ss_code
      getData.card_no = this.$route.query.card_no
      getData.pin_cd = this.$route.query.pin_cd
      getData.x_cls_app_version = this.$route.query.x_cls_app_version
      getData.x_cls_os = this.$route.query.x_cls_os
      getData.x_cls_os_version = this.$route.query.x_cls_os_version
      getData.dpi = this.$route.query.dpi
      getData.devicePixelRatio = this.$route.query.device_pixel_ratio

      return getData
    }
  },
  methods: {
    toInitialAgreement () {
      this.currentState = IS_INITIAL_AGREEMENT
    },
    toAgreement () {
      // [eventTrack]
      this.nativeEVENTSet('CarWashSyokaiRiyouButton', 'MOVED_RIYOU_KIYAKU', 'TAP')
      this.currentState = IS_AGREEMENT
    },
    setSsInfo (ssInfo) {
      this.ssInfo = ssInfo
    },
    openErrorModal (message) {
      modal.alert(message)
    },
    // [初回利用規約画面]上記に同意して次へボタン
    toChargeFromInitialAgreement () {
      // [eventTrack]
      this.nativeEVENTSet('CarWashSyokaiRiyouButton', 'MOVED_CHARGE', 'TAP')
      // チャージ画面へ遷移
      this.toCharge()
    },
    toCharge () {
      // チャージ画面へ遷移
      this.$router.push({
        name: 'V2Charge',
        query: {
          tsid: this.nativeData.tsid,
          otoken: this.nativeData.otoken,
          popinfoid: this.nativeData.popinfoid,
          authid: this.nativeData.authid,
          ss_code: this.nativeData.ss_code,
          card_no: this.nativeData.card_no,
          pin_cd: this.nativeData.pin_cd,
          x_cls_app_version: this.nativeData.x_cls_app_version,
          x_cls_os: this.nativeData.x_cls_os,
          x_cls_os_version: this.nativeData.x_cls_os_version,
          dpi: this.nativeData.dpi,
          device_pixel_ratio: this.nativeData.devicePixelRatio
        }
      })
    }
  },
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(true)

    let isApiError = false

    // SS
    await ssApi.get(this.nativeData.ss_code).then(res => {
      this.setSsInfo(res.data.body.ss_info)
    }).catch(e => {
      console.log('ss-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // [eventTrack]
    this.nativePVset('CARWASH_SYOKAI_RIYOUKIYAKU')

    if (!isApiError) {
      this.loading = false
    }
  },
  components: {
    Loading,
    Agreement
  }
}
</script>
